export type BadgeVariant =
  | 'default' | 'secondary' | 'accent' | 'success' | 'purple' | 'teal' | 'rose' | 'outline';

/**
 * Color per reachability type — each channel gets its own soft hue so adjacent
 * types stay visually distinct: blue = email, amber = fax, teal = sms,
 * green = phone, rose = mobile, violet = app/push (push/whatsapp/webhook),
 * gray = routing (busy/direct), outline = unknown.
 *
 * Shared across the Reachabilities, Notifications & Forwardings, and
 * Communication pages so type colors stay identical everywhere.
 */
export function typeBadgeVariant(type: string): BadgeVariant {
  switch (type) {
    case 'EMAIL':
      return 'default';
    case 'FAX':
      return 'accent';
    case 'SMS':
      return 'teal';
    case 'TELEFON':
      return 'success';
    case 'HANDY':
      return 'rose';
    case 'PUSH':
    case 'WHATSAPP':
    case 'WEBHOOK':
      return 'purple';
    case 'BUSY':
    case 'DIREKT':
      return 'secondary';
    default:
      return 'outline';
  }
}
